export const API_HOST = import.meta.env.VITE_EDR_API_HOST;